import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { ProposalsAPI } from '../../../api/proposals.api';
import { NotificationService } from '../../../services/notification.service'
import { SessionStorageService } from '../../../services/session-storage.service';
import { ProcessService } from '../../../services/process.service';
import { MyToasterService } from '../../../services/my-toaster.service';
import { ProcessAPI } from '../../../api/process.api';
import { DashboardData } from "../../../services/dashboard-data";

@Component({
	selector: 'modal-table-parcelas',
	template: `<div id="modal">
		<button class="btn btn-tn btn-success mt-3 ml-3 mb-3" [disabled]="loading" (click)="changeSimulation()">{{ (loading) ? 'Aguarde' : 'SOLICITAR PROPOSTA' }}</button>
		<button class="btn btn-tn btn-info mt-3 ml-3 mb-3" (click)="closeModal()">Voltar</button>
		<table-parcelas
			[simulacao]='simulacao' [idProposta]='idProposta'>
		</table-parcelas>
	</div>`,
	styleUrls: ['./table-parcelas.component.scss']
})
export class ModalTableParcelasComponent implements OnInit {

	@Input() simulacao: any;
	@Input() idProposta: any;

	public loading = false;

	private propostas;

	constructor(
		private activeModal: NgbActiveModal,
		private ProposalsAPI: ProposalsAPI,
		private processAPI: ProcessAPI,
		private notificationService: NotificationService,
		private session: SessionStorageService,
		private processService: ProcessService,
		private myToaster: MyToasterService,
		public dashboardData: DashboardData,
		public router: Router) { }

	async ngOnInit() {
		this.propostas = await this.ProposalsAPI.setForm(this.idProposta);
	}

	public closeModal() {
		this.activeModal.close();
	}

	public async changeSimulation() {
		try {

			this.loading = true;

			this.propostas.Proposta.id = this.idProposta;
			this.propostas.Proposta.IsSimulacao = 'N';
			this.propostas.Proposta.StatusPagamento = 'P';
			await this.ProposalsAPI.save(this.propostas.Proposta);

			this.dashboardData.data['propostas'] = true;

			// Caso tenha processService.id então está sendo navegado pelo admin e vem da tela de processos
			if (this.processService.id) {
				this.loading = false;
				this.activeModal.close();
				this.router.navigateByUrl('/pages/process/' + this.processService.id + '/proposals');
				return;
			}

			this.notificationService.showNotification({
				'img': 'assets/gif-profile.gif',
				'content': 'Ótimo! Agora que você definiu uma proposta, preciso que você preencha a Ficha Cadastral, em seguida vamos te ajudar com a relação de documentos necessários.',
				'button': {
					'title': 'Preencher Ficha Cadastral',
					'link': '/pages/proposals/form_customer/' + this.propostas.Proposta.ProcessoId + '/' + this.propostas.Proposta.UsuarioId
				}
			});
			this.loading = false;

			this.activeModal.close();
			this.router.navigateByUrl('/pages/proposals/list');
		} catch (err) {
			this.myToaster.showErrorToast('Proposta não solicitada', err);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/table-parcelas/modal-table-parcelas.component.ts